import { Box } from "@mui/material";
import { Typography } from "@platform/design-system";

import { LabeledValue } from "../components";

import type { CarrierDetails } from "../types";

interface CarrierDetailHeaderProps {
  name: string;
  details: CarrierDetails;
}

export const CarrierDetailHeader = ({
  name,
  details,
}: CarrierDetailHeaderProps): React.JSX.Element => {
  const fields = [
    { label: "RFPs in Extract", value: details.rfpsInExtract.toLocaleString() },
    { label: "Active Reps", value: details.activeReps },
    { label: "Rules", value: details.rules },
    { label: "Group", value: details.group },
    { label: "Last Edited", value: details.lastEdited },
  ];

  return (
    <Box display="flex" flexDirection="column" gap={1} p={2}>
      <Typography variant="header-medium" component="h2">
        {name}
      </Typography>
      <Box display="flex" gap={2}>
        {fields.map(({ label, value }) => (
          <LabeledValue key={label} label={label} value={value} />
        ))}
      </Box>
    </Box>
  );
};
